"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _ResetCSS = _interopRequireDefault(require("../assets/styles/ResetCSS"));
require("react-loading-skeleton/dist/skeleton.css");
var _colors = _interopRequireDefault(require("../constants/colors"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultFontOptions = {
  load: true
};
const defaultProps = {
  mode: 'LIGHT',
  colors: _colors.default,
  fontOptions: defaultFontOptions
};
function WrapperThemeProvider(props) {
  const {
    children,
    colors,
    mode,
    fontOptions
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    load
  } = _objectSpread(_objectSpread({}, defaultFontOptions), fontOptions);
  const appColors = (0, _react.useMemo)(() => colors[String(mode).toUpperCase()], [colors, mode]);
  const fonts = load ? "\n    @import url('https://fonts.googleapis.com/css2?family=Cabin:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n    @import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n    @import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,400;0,700;1,700&display=swap');\n    @import url('https://fonts.googleapis.com/css2?family=Catamaran&display=swap');\n  " : '';
  return /*#__PURE__*/_react.default.createElement(_react2.ThemeProvider, {
    theme: {
      colors: appColors,
      mode
    }
  }, /*#__PURE__*/_react.default.createElement(_react2.Global, {
    styles: _ResetCSS.default
  }), /*#__PURE__*/_react.default.createElement(_react2.Global, {
    styles: (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          ", "\n\n          html,\n          body {\n            background: ", ";\n            font-family: 'Cabin', sans-serif;\n          }\n        "])), fonts, appColors === null || appColors === void 0 ? void 0 : appColors.white)
  }), children);
}
var _default = exports.default = WrapperThemeProvider;